import {
  AfterContentInit, AfterViewInit, Component, OnDestroy, OnInit, ViewChild,
  ViewContainerRef
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ITreatyState } from '../../store/reducers/treaty.reducer';
import {select, Store} from '@ngrx/store';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {Configuration} from '@shared/models/configuration';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {QueryProvider} from '@shared/queries/query-provider';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {Subject, timer} from 'rxjs';
import {debounce, takeUntil} from 'rxjs/operators';
import {FileInfo} from '../../models/treaty.models';
import {TreatyApiService} from '../../services/treaty.service';
import {VirtualGridComponent} from '@shared/components/virtual-grid/virtual-grid.component';
import { process, State } from '@progress/kendo-data-query';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
    standalone: false,
    selector: 'particle-treaty-requesting-jurisdiction',
  templateUrl: './treaty-requesting-jurisdiction.component.html',
  styleUrls: ['./treaty-requesting-jurisdiction.component.scss']
})


export class TreatyRequestingJurisdictionComponent implements OnInit, OnDestroy {
  @ViewChild(VirtualGridComponent, {static: true})  gridRef: VirtualGridComponent;
  currentMenu: string;
  ngUnsubscribe$ = new Subject<void>();
  sourceKey: string;
  invalidateSubject: InvalidateSubject;
  breadcrumbs: BreadcrumbModel[];
  breadcrumbs$: any;
  breadcrumbKey: string;
  documentType: string;
  otherVersionsContentViewEnable: boolean;
  otherVersions: FileInfo[];
  inputForm: any;

  private config: any;
  constructor(private store: Store<ITreatyState>,
              protected activatedRoute: ActivatedRoute,
              private queryState: Store<IQueryState>,
              private router: Router,
              private treatyService: TreatyApiService, private formBuilder: FormBuilder) {
    this.breadcrumbKey = 'BreadcrumbByTreatyId';
    this.sourceKey = 'Treaty-Requesting-Jurisdiction';
    this.invalidateSubject = new InvalidateSubject();
    this.inputForm = this.formBuilder.group({
      value  : ['']
    });
  }

  ngOnInit() {
    this.inputForm.valueChanges.pipe(debounce(() => timer(500))).subscribe(data => {
      const state: State = {
        // Initial filter descriptor
        filter: {
          logic: 'and',
          filters: [{ field: 'cells.ReqeustingJurisdiction.displayText', operator: 'contains', value: data.value }]
        }
      };

      this.gridRef.gridView = this.filter(this.gridRef.view, state, data.value);
      console.log('Show the view:::', this.gridRef.gridView);
    });
    this.otherVersionsContentViewEnable = false;
    this.activatedRoute.params.subscribe((params: any) => {
    const id = `treaties-${params.id1}`;

      this.breadcrumbs$ = this.queryState.pipe(takeUntil(this.ngUnsubscribe$), select(getQueryResponse, this.breadcrumbKey));
      this.breadcrumbs$.subscribe(state => {
        if (state) {
          this.breadcrumbs = state.breadcrumb;
        }
      });
      QueryProvider.invokeQuery(this.queryState, this.breadcrumbKey, {'[ID]': `${id}`, '[DOCUMENT_ID]': ''});
      const config = Configuration.getSmartGridConfig(this.sourceKey);
      config.Parameters['PARENT_ID'] = id;
      // this.invalidateSubject.invalidate(id);
    });
  }

  private filter(view: any, state: State, search: string) {
    search = search.toLowerCase();
    console.log('received:::', view);
    const data = view.filter(data => data.cells.RequestedJurisdiction.displayText.toLowerCase().includes(search));
    return {
      data: data,
      total: data.length
    };
  }

  otherVersionDisplay() {

  }

  showPdf(file: any) {

  }



  onGridCellValueChange($event) {
    const id = $event.cells['RequestingJurisdiction'].value;
    const type = $event.cells['Type'].value;
    const countryCode = $event.cells['CountryCode'].value;
    const documentId = $event.cells['DocumentId'].value;
    if (documentId != null) {
      this.router.navigate([`${countryCode.toLowerCase()}/${documentId}`], {relativeTo: this.activatedRoute});
    } else {
      this.router.navigate([`${countryCode.toLowerCase()}`], {relativeTo: this.activatedRoute});
    }

  }


  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}

